const initualState = {
  user: sessionStorage.getItem("user")
    ? JSON.parse(sessionStorage.getItem("user"))
    : null,
  accountOfficer: null,
  alertMessage: null,
  isSidebar: false,
  isLoading: false,
  relationShips: [],
  allEmployers: sessionStorage.getItem("allEmployers")
    ? JSON.parse(sessionStorage.getItem("allEmployers"))
    : []
};

// const initualState = {
//   user: null,
//   alertMessage: null,
//   isSidebar: false
// };

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload };
    case "SET_ALERT_MESSAGE":
      return { ...state, alertMessage: action.payload };
    case "REMOVE_ALERT_MESSAGE":
      return { ...state, alertMessage: null };
    case "REMOVE_USER":
      return { ...state, user: null };
    case "OPEN_SIDEBAR":
      return { ...state, isSidebar: true };
    case "CLOSE_SIDEBAR":
      return { ...state, isSidebar: false };
    case "SHOW_LOADER":
      return { ...state, isLoading: true };
    case "HIDE_LOADER":
      return { ...state, isLoading: false };
    case "SET_ALL_EMPLOYERS":
      return { ...state, allEmployers: action.payload };
    case "SET_RELATIONSHIPS":
      return { ...state, relationShips: action.payload };
    case "SET_ACCOUNT_OFFICER_INFO":
      return { ...state, accountOfficer: action.payload };
    default:
      return state;
  }
};
